/* */ 
(function(process) {
  'use strict';
  var isWindows = /^win/.test(process.platform),
      forwardSlashPattern = /\//g,
      protocolPattern = /^([a-z0-9.+-]+):\/\//i,
      url = module.exports;
  var urlEncodePatterns = [/\?/g, '%3F', /\#/g, '%23', isWindows ? /\\/g : /\//, '/'];
  var urlDecodePatterns = [/\%23/g, '#', /\%24/g, '$', /\%26/g, '&', /\%2C/g, ',', /\%40/g, '@'];
  exports.parse = require('url').parse;
  exports.resolve = require('url').resolve;
  exports.cwd = function cwd() {
    return process.browser ? location.href : process.cwd() + '/';
  };
  exports.getProtocol = function getProtocol(path) {
    var match = protocolPattern.exec(path);
    if (match) {
      return match[1].toLowerCase();
    }
  };
  exports.getExtension = function getExtension(path) {
    var lastDot = path.lastIndexOf('.');
    if (lastDot >= 0) {
      return path.substr(lastDot).toLowerCase();
    }
    return '';
  };
  exports.getHash = function getHash(path) {
    var hashIndex = path.indexOf('#');
    if (hashIndex >= 0) {
      return path.substr(hashIndex);
    }
    return '#';
  };
  exports.stripHash = function stripHash(path) {
    var hashIndex = path.indexOf('#');
    if (hashIndex >= 0) {
      path = path.substr(0, hashIndex);
    }
    return path;
  };
  exports.isHttp = function isHttp(path) {
    var protocol = url.getProtocol(path);
    if (protocol === 'http' || protocol === 'https') {
      return true;
    } else if (protocol === undefined) {
      return process.browser;
    } else {
      return false;
    }
  };
  exports.isFileSystemPath = function isFileSystemPath(path) {
    if (process.browser) {
      return false;
    }
    var protocol = url.getProtocol(path);
    return protocol === undefined || protocol === 'file';
  };
  exports.fromFileSystemPath = function fromFileSystemPath(path) {
    for (var i = 0; i < urlEncodePatterns.length; i += 2) {
      path = path.replace(urlEncodePatterns[i], urlEncodePatterns[i + 1]);
    }
    return encodeURI(path);
  };
  exports.toFileSystemPath = function toFileSystemPath(path, keepFileProtocol) {
    path = decodeURI(path);
    for (var i = 0; i < urlDecodePatterns.length; i += 2) {
      path = path.replace(urlDecodePatterns[i], urlDecodePatterns[i + 1]);
    }
    var isFileUrl = path.substr(0, 7).toLowerCase() === 'file://';
    if (isFileUrl) {
      path = path[7] === '/' ? path.substr(8) : path.substr(7);
      if (isWindows && path[1] === '/') {
        path = path[0] + ':' + path.substr(1);
      }
      if (keepFileProtocol) {
        path = 'file:///' + path;
      } else {
        isFileUrl = false;
        path = isWindows ? path : '/' + path;
      }
    }
    if (isWindows && !isFileUrl) {
      path = path.replace(forwardSlashPattern, '\\');
    }
    return path;
  };
})(require('process'));
